<div class="content-container">
  <p>{{ prompt }}</p>

</div>
<div class="button-container">
  <button pButton pRipple (click)="onNoClick()">Close</button>
  <button pButton pRipple cdkFocusInitial>{{ buttonLabel }}</button>
</div>